(function($) {
    $(function() {
    	$('.filters__btn').click(function(e){
    		$('.filters__btn').toggleClass('active');
    		$('.filters-layout').toggleClass('active');
		});
    });
})(jQuery);
